export const formatIBAN = (iban: string) => {
  const parts =
    iban
      .replaceAll(' ', '')
      .toUpperCase()
      .match(/.{1,4}/g) ?? [];
  return parts.join(' ');
};
